export const STATUS = {
  planned: { label: "Prévu", cls: "bg-[#F2EEE7] text-[#5A635D]" },
  generating: { label: "Génération…", cls: "bg-[#FFF4D6] text-[#8A6100]" },
  ready: { label: "Vidéo prête", cls: "bg-[#E3F5EE] text-[#047857]" },
  publishing: { label: "Publication…", cls: "bg-[#FFF4D6] text-[#8A6100]" },
  published: { label: "Publié", cls: "bg-[#059669] text-white" },
  partial: { label: "Publié en partie", cls: "bg-[#FEF1E7] text-[#D8531E]" },
  failed: { label: "Échec", cls: "bg-[#FDE8E8] text-[#B91C1C]" },
};

export const KIND_LABEL = { restaurant: "Restaurant", dish: "Plat", carpool: "Covoiturage", service: "Service", custom: "Actualité", site: "Nouveauté site" };

export const BUSY = ["generating", "publishing"];

export const videoSrc = (url) => (url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : null);

export const dayLabel = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });

export const topicTitle = (t) => (t?.label || "").split(" · ").slice(1).join(" · ") || t?.label || "";
